import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ExperienceCard } from './OfferCards';
import { Button } from './ui/button';
import { api } from '../lib/api';
import { openDeal } from '../lib/deals';
import { Ticket, ArrowRight } from 'lucide-react';

// Destination-matched Viator experiences shown on flight/hotel result pages.
// Reuses the SAME /api/experiences/search (provider=viator) + native ExperienceCard, and
// routes every CTA through the central /api/go engine (via the detail page or openDeal).
export const ExperienceCrossSell = ({ city = '', code = '', currency = 'INR', limit = 4, source = '/flights/results' }) => {
  const navigate = useNavigate();
  const [items, setItems] = useState(null); // null = loading, [] = none
  const [demo, setDemo] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!city && !code) { setItems([]); return undefined; }
    api.experiences({ provider: 'viator', destination: city, destination_code: code, currency })
      .then(({ data }) => {
        if (!alive) return;
        setDemo(!!data.is_mock);
        setItems((data.offers || []).slice(0, limit));
      })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [city, code, currency, limit]);

  const onView = (offer) => {
    if (offer.product_code) {
      const q = new URLSearchParams({
        city: offer.city || city || '',
        ...(offer.price_inr ? { price: String(offer.price_inr) } : {}),
        ...(offer.duration_hours ? { dur: String(offer.duration_hours) } : {}),
      }).toString();
      navigate(`/experiences/${offer.product_code}?${q}`);
      return;
    }
    openDeal({ type: 'experience', offer, surface: 'cross_sell', placement: 'cross_sell', source });
  };

  if (items === null) return null; // keep results page clean while loading
  if (!items.length) return null;

  return (
    <section className="mt-8" data-testid="experience-cross-sell">
      <div className="flex items-end justify-between mb-3">
        <h2 className="font-display text-lg font-semibold flex items-center gap-2">
          <Ticket className="h-5 w-5 text-accent" /> Things to do{city ? ` in ${city}` : ''}
          {demo && <span className="ml-2 text-[10px] bg-secondary px-2 py-0.5 rounded align-middle">demo</span>}
        </h2>
        <Button variant="ghost" size="sm" className="text-xs"
          onClick={() => navigate(code ? `/experiences?destination_code=${code}` : `/experiences?keyword=${encodeURIComponent(city)}`)}
          data-testid="experience-cross-sell-see-all">
          See all <ArrowRight className="h-3.5 w-3.5 ml-1" />
        </Button>
      </div>
      <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
        {items.map((o) => (
          <ExperienceCard key={o.offer_id} offer={o} currency={currency} onViewDeal={onView} />
        ))}
      </div>
    </section>
  );
};

export default ExperienceCrossSell;
